import merge from 'deepmerge'

type Workspace = 'dev' | 'preprod' | 'prod'

interface OAuthBaseConfig {
  scope: string
  client_id: string
  response_type: string
  redirect_uri: string
}

interface OAuthTokenConfig {
  authorization: string
  token: string
}

type OAuthConfig = OAuthBaseConfig & OAuthTokenConfig

export interface GraphqlConfig {
  appName: string
  appFullName: string
  graphqlEndpoint: string
  workspace: Workspace
  oAuth: OAuthConfig
}

const isLocalhost = () => window.location.origin.includes('localhost:')
const isDev = () => window.location.origin.includes('dev.sensors-test.nikecloud')
const isPreProd = () => window.location.origin.includes('preprod.sensors-test.nikecloud')

interface BaseConfig {
  appName: string
  appFullName: string
  oAuth: OAuthBaseConfig
}

const base: BaseConfig = {
  appName: 'qr-redirect-automation',
  appFullName: 'QR Redirect Automation',
  oAuth: {
    scope: 'profile openid email offline_access connected_product:connectedid.qrredirect.admin::read:',
    client_id: 'nike.niketech.qr-redirect-automation',
    response_type: 'authorization_code',
    redirect_uri: window.location.origin + '/'
  }
};

const applyOverrides = (
  overrides: { graphqlEndpoint: string; workspace: Workspace; oAuth: OAuthTokenConfig }
): GraphqlConfig => merge(base, overrides) as GraphqlConfig

const localhost = applyOverrides({
  graphqlEndpoint: 'https://qr-redirect-automation-api-dev.sensors-test.nikecloud.com/graphql',  // Deployed backend
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'dev'
})

const dev = applyOverrides({
  graphqlEndpoint: 'https://qr-redirect-automation-api-dev.sensors-test.nikecloud.com/graphql',  // Full URL for deployed dev
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'dev'
})

const preprod = applyOverrides({
  graphqlEndpoint: 'https://qr-redirect-automation-api-preprod.sensors-test.nikecloud.com/graphql',
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'preprod'
})

const prod = applyOverrides({
  graphqlEndpoint: 'https://qr-redirect-automation-api.sensors.nikecloud.com/graphql',
  oAuth: {
    authorization: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize',
    token: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/token'
  },
  workspace: 'prod'
})

let config: GraphqlConfig
if (isPreProd()) {
  config = preprod
} else if (isDev()) {
  config = dev
} else if (isLocalhost()) {
  config = localhost
} else {
  config = prod
}

export default config
